<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增岗位' : '编辑岗位'"
    :enableDrag="true"
    width="500px"
    @close="cancel">
    <dynamic-form :formConfig="formConfig" v-model="form" @submit="doSubmit" @cancelForm="cancel" ref="pageForm"></dynamic-form>
  </drag-dialog>
</template>

<script>
import { add, edit } from '@/api/job'
import DragDialog from '@/components/DragDialog'
import '@/components/dynamic-form'
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    treeData: {
        type: Array,
        default: () => ([])
    },
    supThis: {
      type: Object,
    }
  },
  components: {
    DragDialog
  },
  watch: {
      treeData: function(val) {
          this.$nextTick(() => {
              this.$set(this.formConfig.formItemList[2], 'options', val)
          })
      },
    dialog(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.pageForm.$refs.dynamicForm.clearValidate();
          });
        }
    }
  },
  data() {
    return {
      loading: false, dialog: false,
      form: {},
      formConfig: {
        formItemList: [
            {
              type: "input",
              key: "name",
              label: "岗位名称",
              value: "",
              placeholder: "请输入名称",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "input",
              key: "code",
              label: "岗位编码",
              value: "",
              placeholder: "请输入编码",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
                label: '所属组织',
                key: 'deptId',
                type: 'treeSelect',
                multiple: false,
                value: '',
                clearable: true,
                filterable: false,
                props: {
                    children: 'children',
                    label: 'name',
                    value: 'id'
                },
                options: this.treeData,
                rules: {
                    required: true, message: '不能为空', trigger: 'change'
                }
            },
            {
                type: 'input',
                label: '排序号',
                key: 'sort',
                subtype: 'number',
                value: '',
                placeholder: '请输入数字'
            },
            {
                type: 'textarea',
                label: '备注',
                key: 'remark',
                value: ''
            }
        ]
      }
    }
  },
  methods: {
    cancel() {
      this.resetForm()
    },
    doSubmit(val) {
      this.form = val
      if (this.isAdd) {
          this.doAdd()
      } else this.doEdit()
    },
    doAdd() {
      add(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '添加成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.supThis.dataTableInit()
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    doEdit() {
      edit(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '修改成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.supThis.dataTableInit()
      }).catch(err => {
        this.loading = false
        console.log(err.response.data.message)
      })
    },
    resetForm() {
      this.dialog = false
      this.$refs.pageForm.resetForm()
    }
  }
}
</script>

<style scoped>

</style>
